export default __webpack_public_path__ + "assets/payment-icons/diners.f2c52009cc5ef92e31727a4cb4c9baa4.svg";